export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    fontFamily: "'Goldman', sans-serif",
  },
  h2: {
    fontWeight: 600,
    fontSize: 30,
    fontFamily: "'Goldman', sans-serif",
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "'Goldman', sans-serif",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "'Goldman', sans-serif",
  },
  h5: {
    fontWeight: 300,
    fontSize: 18,
    fontFamily: "'Goldman', sans-serif",
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    fontFamily: "'Red Rose', sans-serif",
    "@media (max-width:767px)": {
      fontSize: "16px !important",
    },
  },
  overline: {
    fontWeight: 500,
    fontFamily: "'Red Rose', sans-serif",
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Goldman', sans-serif",
  },
  body1: {
    fontSize: 12,
    fontFamily: "'Red Rose', sans-serif",
  },
  body2: {
    fontWeight: 300,
    fontSize: 14,
    fontFamily: "'Red Rose', sans-serif",
  },
};
